import { Dtos, SuretyAccountId } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { financialExtractionsQueryKey } from "./financials.keys";

export const useFetchFinancialExtractions = (
	accountId: SuretyAccountId,
	enabled: boolean = true,
) => {
	const { get } = useRequest();
	const { isAdmin } = useAuthenticatedUser();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: financialExtractionsQueryKey(accountId),
		enabled,
		queryFn: async () =>
			await get<Dtos.FinancialExtraction.Get.Response[]>(
				`/v2/${isAdmin ? "admin/" : ""}surety/accounts/${accountId}/financial-extractions`,
			),
	});

	return {
		financialExtractions: data,
		financialExtractionsError: error,
		financialExtractionsLoading: isLoading,
		refetchFinancialExtractions: refetch,
	};
};
